module.exports = __webpack_public_path__ + "static/media/Apple Watch 38mm Silver Aluminum + Ocean Blue Closed.9f18eaba.png";